"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
owa_bundling_1.preloadScriptChunk('FeedbackForm');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "FeedbackForm" */ './lazyIndex');
});
exports.FeedbackForm = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.FeedbackForm; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-feedback/lib/index.js
// module id = 6214
// module chunks = 38